( function( $, document, window ) {
	'use strict';

	$( function() {
		const swiper = new Swiper('.js-logo-carousel', {
			direction: 'horizontal',
			slidesPerView: 2,
			slidesPerGroup: 2,
			spaceBetween: 20,
			loop: false,
			centerInsufficientSlides: true,

			breakpoints: {
				640: {
					slidesPerView: 3,
					slidesPerGroup: 3,
					spaceBetween: 40,
				},
				768: {
					slidesPerView: 4,
					slidesPerGroup: 4,
					spaceBetween: 60,
				},
				1024: {
					slidesPerView: 6,
					slidesPerGroup: 6,
					spaceBetween: 80,
				},
				1400: {
					slidesPerView: 8,
					slidesPerGroup: 8,
					spaceBetween: 80,
				}
			},

			pagination: {
				el: '.js-logo-carousel-pagination',
				type: 'bullets',
				clickable: true,
			},
		});
	} );
} )( jQuery, document, window );
